<template>
  <footer class="footerNavigation">
    <div class="footerNavigation_item" @click="$router.push({ path: '/home' })">
      <div>
        <img :src="getFootIcon('home')" alt="" />
      </div>
      <div>首页</div>
    </div>
    <div class="footerNavigation_item" @click="$router.push({ path: '/meet' })">
      <div>
        <img :src="getFootIcon('meet')" alt="" />
      </div>
      <div>发帖</div>
    </div>
    <div class="footerNavigation_item" @click="$router.push({ path: '/my' })">
      <div>
        <img :src="getFootIcon('my')" alt="" />
      </div>
      <div>我的</div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "footerNavigation",
  methods: {
    getFootIcon(type) {
      if (this.$route.path.includes(type)) {
        return require(`@/assets/images/common/${type}_h.png`);
      } else {
        return require(`@/assets/images/common/${type}.png`);
      }
    },
  },
};
</script>
<style>
.footerNavigation {
  width: 100%;
  z-index: 99999;
  padding: 0.5rem 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid #e8ebf3;
  font-size: 12px;
}
.footerNavigation_item {
  padding: 0.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.footerNavigation img {
  height: 18px;
  margin-bottom: 2px;
}
</style>